<template>
  <div class="login-form-home sign-up-form text-left" >
    <div class="login-form-wrapper">
      <div class="bp-logo">
          <img src="@/assets/images/logos/BP.png" alt="logo">
          <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
      </div>
      

      <div class="wrong-page text-align-left" v-if="!linkIsValid && pageLoaded && !redeemedLink">
        {{ $t('OUTER_PAGES.common.notValid')}}
      </div>

      <div class="wrong-page text-align-left" v-if="notFound">
        {{ $t('OUTER_PAGES.common.notFound')}}
      </div>

      <div v-if="linkIsValid & pageLoaded && !redeemedLink" class="text-align-left">
        <i18n path="OUTER_PAGES.common.confirmed">
          <router-link slot="loginPage" class="link underline" :to="{ name: 'Login' }">{{ $t('OUTER_PAGES.variables.loginPage')}}</router-link>
        </i18n>
      </div>

      <div v-if="redeemedLink & pageLoaded" class="text-align-left">
        {{ $t('OUTER_PAGES.additionalEmailConfirm.redeemedLink')}}
      </div>
    </div>
  </div>
</template>

<script>
import { CONFIRM_ADDITIONAL_EMAIL_URL } from '@/constants/ApiConstants'
import ApiService from '@/common/api.service'
import STATUS_CODES from '@/common/statusCodes'

export default {
  name: 'AdditionalEmailConfirm',
  data () {
    return {
      linkIsValid: false,
      pageLoaded: false,
      redeemedLink: false,
      notFound : false
    }
  },
  computed: {
    confirmationToken: {
      get () {
        return this.$route.params.token
      }
    }
  },
  mounted () {
    ApiService.get(`${CONFIRM_ADDITIONAL_EMAIL_URL.replace(':token', this.confirmationToken)}`)
      .then(response => {
        if(response.status.code === STATUS_CODES.BP_412) {
          this.pageLoaded = true
          this.redeemedLink = true
        } else if (response.status.code === STATUS_CODES.BP_404) {
          this.notFound = true
        } else if (response.status.code === STATUS_CODES.BP_405) {
          this.pageLoaded = true
        } else {
          this.pageLoaded = true
          this.linkIsValid = true
        }
      })
      .catch((error) => {
        this.pageLoaded = true
        
      })
  }
}
</script>

